export const PROJECT_MEMBER_STATUS = {
  ALLOWED: 'allowed',
  UNALLOWED: 'unallowed',
};
